// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_fl-6";
export var emphasizeQuantity = "_fl-3";
export var flatBottomCorners = "_fl-5";
export var productImage = "_fl-0";
export var quantityContainer = "_fl-2";
export var tooltip = "_fl-1";
export var wrapAndEllipsesOverflow = "_fl-4";